import { InputCheckbox, Stack, Text } from "@bookingcom/bui-react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { FilterCount } from "@flights/search-ui";
import useUserAgent from "hooks/useUserAgent";
import React from "react";
import useSearchFiltersController from "../useSearchFiltersController";
import flights_apex_web_filter_on_flexible_ticket from "utils/experiments/apex/flights_apex_web_filter_on_flexible_ticket";

const FlexibilityFilter = () => {
  const i18n = useI18n();
  const { isMobile } = useUserAgent();
  const { flexibility } = useSearchFiltersController();

  if (!flexibility.flexibleTicket.count || !flights_apex_web_filter_on_flexible_ticket.trackWithDefaultStage())
    return null;

  return (
    <Stack gap={isMobile ? 4 : 2} attributes={{ "data-testid": "flexible-ticket-filter" }}>
      <Text variant="emphasized_1">{i18n.trans(t("flights_filters_flexibility_title"))}</Text>
      <FilterCount count={flexibility.flexibleTicket.count}>
        <InputCheckbox
          checked={flexibility.flexibleTicket.checked}
          onChange={({ checked }) => flexibility.set(checked, "flexibleTicket")}
          label={
            <>
              <Text>{i18n.trans(t("flights_filters_flexibility_flex_ticket"))}</Text>
              <Text color="neutral_alt">{i18n.trans(t("flights_filters_flexibility_flex_ticket_sub"))}</Text>
            </>
          }
          name="flexibleTicket"
        />
      </FilterCount>
    </Stack>
  );
};

export default FlexibilityFilter;
